/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 1主企业| 2渠道商企业| 11个人版
   */
  corp_category?: number;
  /**
   * 操作类型，change_uin:换绑uin | from_cloud_auth: 野鹤授权（后台调用专用）
   */
  do_type?: string;
}
export interface PayLogicNarSassGetSaasCodeRes {
  /**
   * 0成功 | 300100跳转云Auth授权
   */
  code: number;
  msg: string;
  data: Data;
}
export interface Data {
  /**
   * 腾讯云uin
   */
  uin: string;
  /**
   * 透传回去，方便定位问题
   */
  corp_category: number;
  /**
   *  云code，换取云控制台登录态
   */
  saas_code: string;
  /**
   * 云跳转业务appid, url跳转时带上
   */
  cloud_url_appid: string;
  /**
   *  云跳转业务state，用于区分业务类型, url跳转时带上
   */
  cloud_url_state: string;
}

const PayLogicNarSassGetSaasCode = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<PayLogicNarSassGetSaasCodeRes>(
    '/wemeet-tapi',
    '/v2/pay-logic-nar/sass/get-saas-code',
    data,
    ctx,
  );

  return res;
};

export default PayLogicNarSassGetSaasCode;
